// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2EpWz","left":"StickyBox_left__3yIUm","right":"StickyBox_right__3Bz4Y"};